import action from "../helpers/rest-client";

export class ErrorMedia extends Error { }

class Media {
  public async getMedia(mediaId: number) {
    return action
      .Get({
        url: `/api/media/${mediaId}`,
      })
      .then((response) => {
        return { response };
      })
      .catch((error) => {
        return { error };
      });
  }
}

const media = new Media();
export default media;
